// The phone breakpoint (styles/shell.css `@media (max-width: 960px)`): under it the sidebar is a
// drawer that slides in and out. Crossing it (a window resized, a device turned) must move the
// sidebar at once: without this, the drawer's 0.2 s slide kept it visible, half clipped, right
// after a resize from wide to phone, and axe found the Explore row's target too small (APS-376).
import { useEffect } from 'react'

export const PHONE = '(max-width: 960px)'

/** The class that turns the drawer's slide off while the layout changes (shell.css). */
export const SNAP = 'nav-snap'

/**
 * Calls `onCross` each time the window crosses the phone breakpoint, with the sidebar's slide off
 * for the frame that moves it.
 */
export function usePhoneBreakpoint(onCross: (phone: boolean) => void): void {
  useEffect(() => {
    const mq = typeof window.matchMedia === 'function' ? window.matchMedia(PHONE) : null
    if (!mq) return
    let frame = 0
    const onChange = (e: MediaQueryListEvent) => {
      const root = document.documentElement
      root.classList.add(SNAP)
      onCross(e.matches)
      cancelAnimationFrame(frame)
      // Two frames: the layout moves with the slide off, then the slide is back for a tap.
      frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(() => root.classList.remove(SNAP))
      })
    }
    mq.addEventListener('change', onChange)
    return () => {
      mq.removeEventListener('change', onChange)
      cancelAnimationFrame(frame)
      document.documentElement.classList.remove(SNAP)
    }
  }, [onCross])
}
